import React, { useEffect, useState } from "react";

import checkoutSteps from "../../../../../providers/HelCheckoutSteps";
import StorageHandler from "../../../../../utils/StorageHandler";
import resolveWebView from "../../../../../utils/webViewRedirect";
import CalculatorMessage from "../../../../shared/CalculatorMessage";
import CalculatorProductDetails from "../../../../shared/CalculatorProductDetails";
import CalculatorProducts from "../../../../shared/CalculatorProducts";
import { navigate } from "../../../../shared/LinkComponent";
import LoadingIndicator from "../../../../shared/LoadingIndicator";
import Margin from "../../../../shared/Margin";
import useStepDeliveryAddressStore from "../../CheckoutPage/StepDeliveryAddress/store";
import useStepDeliveryDetails from "../../CheckoutPage/StepDeliveryDetails/store";
import useAmountStore from "../../CheckoutPage/StepOverview/Amount/store";
import useCheckoutPageStore from "../../CheckoutPage/store";
import useCalulatorStore from "../store";
import Product from "./Product";
import UnsupportedZipcode from "./UnsupportedZipcode";

const storage = new StorageHandler();

const CalculatorResult = () => {
    const [
        amount,
        result,
        loading,
        productChoice,
        loadingError,
        additions,
        zipcodeIsValid,
        checkedZipcode,
        setProductChoice,
        syncProductInfos,
    ] = useCalulatorStore((state) => [
        state.amount,
        state.result,
        state.loading,
        state.productChoice,
        state.loadingError,
        state.additions,
        state.zipcodeIsValid,
        state.checkedZipcode,
        state.setProductChoice,
        state.syncProductInfos,
    ]);

    const [clearCheckout] = useCheckoutPageStore((state) => [
        state.clearCheckout,
    ]);

    const [setAmountStorageToState] = useAmountStore((state) => [
        state.setAmountStorageToState,
    ]);

    const [clearDeliveryAddress] = useStepDeliveryAddressStore((state) => [
        state.clearDeliveryAddress,
    ]);

    const [clearDeliveryDetails] = useStepDeliveryDetails((state) => [
        state.clearDeliveryDetails,
    ]);

    const [expanded, setExpanded] = useState([]);

    const zipcodeInput = storage.get("hel:last-zipcode-input-value", "");

    const isExpanded = (itemIndex) => {
        return expanded.includes(itemIndex);
    };

    const toggleExpand = (itemIndex) => {
        if (isExpanded(itemIndex)) {
            setExpanded(expanded.filter((item) => item !== itemIndex));
        } else {
            setExpanded([...expanded, itemIndex]);
        }
    };

    const clearCheckoutProcess = () => {
        clearCheckout();
        setAmountStorageToState();
        clearDeliveryAddress();
        clearDeliveryDetails();
    };

    useEffect(() => {
        setExpanded([]);
    }, [result]);

    return (
        <>
            {loading && <LoadingIndicator />}
            {!loading &&
                !zipcodeIsValid &&
                checkedZipcode.length === 5 &&
                result.length === 0 && (
                    <UnsupportedZipcode zipcode={checkedZipcode} />
                )}
            {!loading && result.length > 0 && (
                <>
                    {additions.show_message && additions.show_message == 1 && (
                        <CalculatorMessage>
                            <span>
                                Lieferung erfolgt erst in 2021 -{" "}
                                <strong>
                                    daher ist die CO2-Abgabe bereits im Preis
                                    eingerechnet!
                                </strong>
                            </span>
                        </CalculatorMessage>
                    )}
                    <CalculatorProducts
                        products={result}
                        activeIndex={productChoice}
                        onIndexChange={setProductChoice}
                        subline="Preis 100 l inkl. MwSt."
                    />
                    <CalculatorProductDetails activeIndex={productChoice}>
                        {result.map((product, idx) => {
                            return (
                                <Product
                                    key={idx}
                                    product={product}
                                    amount={amount}
                                    expanded={isExpanded(idx)}
                                    onExpand={() => toggleExpand(idx)}
                                    onSubmit={() => {
                                        setProductChoice(idx);

                                        let url = checkoutSteps[0].url;
                                        if (product.isPremium) {
                                            url = checkoutSteps[1].url;
                                        }

                                        clearCheckoutProcess();

                                        setTimeout(() => {
                                            syncProductInfos(product);
                                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                                            void navigate(
                                                resolveWebView(
                                                    "/heizoel/bestellung/" + url
                                                )
                                            );
                                        }, 0);
                                    }}
                                />
                            );
                        })}
                    </CalculatorProductDetails>
                </>
            )}
            {loadingError && zipcodeInput.length < 5 && (
                <Margin top="20" bottom="20">
                    Daten konnten nicht geladen werden. Überprüfen Sie bitte
                    Ihre Eingaben.
                </Margin>
            )}
        </>
    );
};

export default CalculatorResult;
